import { useState } from "react";
import { usePDF } from "react-to-pdf";

const usePdf = (fileTitle) => {
  const [loading, setLoading] = useState(false);

  const { toPDF, targetRef } = usePDF({
    filename: fileTitle,
    scale: 1, // Adjust the scale as needed
    options: {
      format: "A4", // Specify the page size (e.g., "letter", "A4")
    },
  });

  const generatePDF = async () => {
    await setLoading(true);
    await toPDF();
    await setLoading(false);
  };

  return { targetRef, loading, generatePDF };
};

export default usePdf;
